import {isVersionHigherThan, isVersionHigherThanMulti} from '@/utils'
import getUaParam from '@/utils/getUaParam'
import {IS_PROD} from './env'
// scheme大全
// https://wiki.baijia.com/pages/viewpage.action?pageId=29317630
const {isApp} = getUaParam()
// 打开tab页
export const ENTRY_TAB_SCHEME = 'entry_tab'

// 4.67后各app版本统一
// 支持全屏的版本
export const FULLSCREEN_VERSION = '4.66.0'

// 打开tab页
export const SCAN_SCHEME = 'multi_scan'

// 支持绑定图书的版本
export const BIND_VERSION = '4.69.0'
export const isBindVersion = () => {
    // 非高途app支持全屏
    if (!isApp) {
        return false
    }
    // 高途app有版本限制
    return isVersionHigherThan(BIND_VERSION)
}

// 支持拍照批改的版本
export const PHOTO_VERSION = '4.71.0'
export const isPhotoVersion = () => {
    // 非高途app支持全屏
    if (!isApp) {
        return false
    }
    // 高途app有版本限制
    return isVersionHigherThan(PHOTO_VERSION)
}

// 支持ios全屏端能力的版本
export const IOS_FULLSCREEN_VERSION = '4.71.0'
export const isIOSFullscreenVersion = () => {
    // 非高途app支持全屏
    if (!isApp) {
        return false
    }
    // 高途app有版本限制
    return isVersionHigherThan(IOS_FULLSCREEN_VERSION)
}

// 打开错题本
export const ERROR_BOOK_SCHEME = 'error_book'
// 在线客服
export const CUSTOM_SERVICE_SCHEME = 'customer_service'

// 支持语音测评的版本
export const EVALUATION_VERSION = '4.77.0'
export const EVALUATION_SCHEME = 'voice_evaluate'

export const NO_ANIMATION_VERSION = '4.78.0'

export const AUDIO_VERSION = '4.79.0'
export const AUDIO_SCHEME = 'study_book_audio_player'

export const LISTENING_VERSION = '4.80.0'
// export const LISTENING_PREVIEW_SCHEME = 'listening_preview';
// export const LISTENING_SCHEME = 'listening';
// export const LISTENING_RESULT_SCHEME = 'listening_result';
export const LLRM_VERSION = '4.83.0'
export const LLRM_SCHEME = 'learn_book_speak_recite'

// ios 作文批改存在打开直接崩哭的问题，此版本修复
export const WRITING_VERSION = '4.87.0'
// export const WRITING_VERSION = IS_PROD ? '4.84.0' : '4.83.0'

// 口算拍批版本
export const MENTAL_VERSION = '4.85.0'
// 扫码页添加口算拍批tab版本
export const MENTAL_VERSION_NEW = '4.86.0'
// 反馈页面
export const FEED_BACK = 'feed_back'
//打开口算批改页面
export const MENTAL_SCHEME = 'learn_calculate_correct'

// 新批改入口，每个批改页面都变成单个入口
export const PHOTO_NEW = '4.88.0'
export const PHOTO_NEW_SCHEME = 'learn_correct'

